export const ANALYTICS_EVENTS = Object.freeze({
  PAGE_VIEW: 'page_view',
  PURCHASE: 'purchase',
})
